import axios from './axiosInstance'

async function getAnswer(question, threadId, token) {
  let response = await axios.post('/assistant/answer', { question, thread_id: threadId },
    { headers: {"X-CAPTCHA-TOKEN": token}
  })
  if (response?.data?.status_code === 404) {
    try {
      let { data } = await axios.post("/user/create_uuid")
      localStorage.setItem("uuid", data.id)
      // fix - 1
      window.location = '/chats/new'
      // response = await axios.post('/assistant/answer', { question, thread_id: threadId })
    } catch (error) {
      console.log(error)
      return
    }
  }
  return response
}

function getAllThreads() {
  return axios.get('/assistant/threads')
}

function getThreadHistory(threadId) {
  return axios.get(`/assistant/threads/${threadId}/history`)
}

function deleteAllThreads() {
  return axios.delete('/assistant/threads/all')
}

function deleteThread(threadId, token) {
  return axios.delete(`/assistant/threads/${threadId}`,
    { headers: { "X-CAPTCHA-TOKEN": token }})
}

function sendFeedback(feedback, token) {
  return axios.post(`/assistant/message/feedback`, feedback, {headers: {"X-CAPTCHA-TOKEN": token}})
}

function subscribeToRoom(userId, roomId) {
  return axios.post('/ws/register_to_room/', {
    user_id: userId,
    room_id: roomId,
  })
}

export default {
  getAnswer,
  getAllThreads,
  deleteThread,
  deleteAllThreads,
  getThreadHistory,
  sendFeedback,
  subscribeToRoom,
}
